import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import get from 'lodash/get'
import style from './BlogPage.module.scss'
import kebabCase from 'lodash/kebabCase'

class BlogPage extends Component {
  static propTypes = {
    posts: PropTypes.array,
    intl: PropTypes.object,
  }

  state = {
    postsCount: 9
  }

  blogList = React.createRef()
  loadMore = React.createRef()

  loadMorePosts = () => this.setState(prevState => ({ postsCount: prevState.postsCount + 3 }))

  componentDidUpdate(prevProps, prevState) {
    if (prevState.postsCount !== this.state.postsCount && this.loadMore.current) {
      this.loadMore.current.scrollIntoView({ behavior: 'smooth', block: window.innerWidth > 1365 ? 'center' : 'end' })
    }
  }

  render() {
    const { posts, intl } = this.props
    const { postsCount } = this.state
    const postsToShow = posts.slice(0, postsCount)
    return (
      <div className={style.blog}>
        <div className={style.innerContainer}>
          <h1>{intl.messages.blogPage.title}</h1>
          <div className={style.blogList} ref={this.blogList}>
            {postsToShow.map(({ node }) => {
              const title = get(node, 'frontmatter.title') || node.fields.slug
              return (
                <div key={node.fields.slug} className={style.blogItem}>
                  <Link to={`/${intl.locale}${node.fields.slug}`}></Link>
                  <h4>{title}</h4>
                  <small>{node.frontmatter.date}</small>
                  {node.frontmatter.tags && node.frontmatter.tags[0] && (
                    <div className={style.blogTags}>
                      {node.frontmatter.tags.map((tag, index) => {
                        return (
                          <Link key={index} to={`/${intl.locale}/tags/${kebabCase(tag)}/`}>{tag}</Link>
                        )
                      })}
                    </div>
                  )}
                  <p dangerouslySetInnerHTML={{ __html: node.excerpt }} />
                </div>
              )
            })}
          </div>
          <div className={style.blogMore} ref={this.loadMore}>
            {postsCount < posts.length && (
              <button className={style.blogMoreBtn} onClick={this.loadMorePosts}>{intl.messages.blogPage.moreBtn}</button>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default BlogPage
